var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",on:{"click":_vm.displayComplianceDetailsPopup}},[_c('div',{staticClass:"name-data-cell"},[_vm._v(" "+_vm._s(_vm.getDescription)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }